import PropTypes from "prop-types";
import { Select } from "antd";

const CandidateStats = () => {
  return (
    <div>
      <div className="items-center justify-between md:flex">
        <h1 className="mb-6 font-bold heading-large">Candidate&apos;s Stats</h1>

        <div className="flex items-center mb-6">
          <span className="mr-4 text-bold">Filter by</span>
          <div className="flex gap-4">
            <div className="relative">
              <Select defaultValue="Location" />
            </div>
            <div className="relative">
              <Select defaultValue="2023" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CandidateStats.propTypes = {
  registeredVoters: PropTypes.number,
  lastUpdated: PropTypes.string,
  location: PropTypes.string,
};

export default CandidateStats;
